export default [
  {
    path: '/student-scoring-entries',
    name: 'student-scoring-entry',
    meta: { requiresAuth: true },
    component: () => import('@/pages/student-scoring-entry/index.vue')
  },
  {
    path: '/student-scoring-entries/create',
    name: 'student-scoring-entry-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/student-scoring-entry/create.vue')
  },
  {
    path: '/student-scoring-entries/table-entries',
    name: 'student-scoring-entry-table',
    meta: { requiresAuth: true },
    component: () => import('@/pages/student-scoring-entry/table-entry.vue')
  },
  {
    path: '/student-scoring-entries/table-edit',
    name: 'student-scoring-entry-table-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/student-scoring-entry/table-entry-edit')
  }
]
